import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../components/Reveal';
import MailLink from '../components/MailLink';
import { SITE } from '../content/site';
import './Contact.css';

const REASONS = [
  {
    id: 'project',
    label: 'Start a project',
    blurb: 'An idea, a scope, or an app that needs rescuing.',
    subject: 'Project enquiry',
  },
  {
    id: 'support',
    label: 'App support',
    blurb: 'Something is broken, missing or behaving oddly.',
    subject: 'App support',
  },
  {
    id: 'privacy',
    label: 'Privacy request',
    blurb: 'Access, correction, deletion or a complaint.',
    subject: 'Privacy request',
  },
];

function Contact() {
  return (
    <main id="main" className="contact">
      <div className="contact-hero">
        <div className="contact-glow" aria-hidden="true" />
        <div className="wrap">
          <nav className="crumbs">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Contact</span>
          </nav>
          <h1>
            Say what it <span className="gradient-text">does</span>.
          </h1>
          <p className="legal-lede">
            One mailbox, read by the people who write the code. Pick the reason
            and it writes the subject line for you.
          </p>

          <div className="mail-row">
            <MailLink className="btn" subject="Hello AppNexa">
              Email the studio
            </MailLink>
            <Link className="btn ghost" to="/delete-account">
              Delete an account
            </Link>
          </div>
        </div>
      </div>

      <section className="reasons">
        <div className="wrap grid-3">
          {REASONS.map((reason, i) => (
            <Reveal key={reason.id} delay={i * 80}>
              <MailLink className="reason card-surface" subject={reason.subject}>
                <h3>{reason.label}</h3>
                <p>{reason.blurb}</p>
                <span className="reason-go">
                  Write to us <i>→</i>
                </span>
              </MailLink>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="contact-facts">
        <div className="wrap">
          <Reveal className="facts-box card-surface">
            <div>
              <h3>Response time</h3>
              <p>Two working days for most things, 30 days at the outside for a formal privacy request.</p>
            </div>
            <div>
              <h3>Studio</h3>
              <p>
                {SITE.name}, independent mobile app studio. Google Play developer
                ID {SITE.playDeveloperId}.
              </p>
            </div>
            <div>
              <h3>Deleting an account?</h3>
              <p>
                That has its own page with the fastest route:{' '}
                <Link to="/delete-account">delete your account</Link>.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}

export default Contact;
